import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height="3.2mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22360 10522"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974535736576">
        <path
          d="M11207 2473H7214c0 2813 1788 5093 3993 5093s3993-2280 3993-5093h-3993zm45 1322h2395c0 1406-1073 2546-2395 2546-1324 0-2396-1140-2396-2546h2396z"
          className="fil0"
        />
        <path
          d="M11180 0c6174 0 11180 760 11180 1698 0 937-5006 1697-11180 1697S0 2635 0 1698C0 760 5006 0 11180 0zm33 777c5293 0 9583 380 9583 848 0 469-4290 849-9583 849-5292 0-9582-380-9582-849 0-468 4290-848 9582-848zM6582 3858l-1749 163c-132 12-249-92-260-232-12-139 86-264 218-276l1749-162c132-12 249 91 260 231 12 140-86 264-218 276zM6916 5038l-1650 638c-125 48-263-20-308-152-45-131 20-279 144-327l1650-638c124-47 262 21 307 152v1c45 131-19 278-143 326zM7551 6062 6205 7263c-100 90-252 76-337-32-85-107-72-268 29-359l1346-1200c102-90 253-75 338 32 85 108 71 268-30 358zM8400 7158l-879 1619c-66 121-213 163-327 93s-154-227-88-348l879-1618c66-121 213-163 327-93 114 71 154 227 88 347zM9560 7860l-305 1841c-23 137-147 230-277 205h-1c-129-24-217-156-194-294l305-1840c23-138 148-231 278-206 130 24 217 157 194 294zM15857 3856l1749 163c132 12 249-92 260-231v-1c12-139-86-263-218-276l-1749-162c-132-13-249 91-260 231v1c-12 139 86 263 218 275zM15485 4909l1649 639c124 47 263-21 308-152 45-132-19-279-144-327l-1649-638c-125-48-263 21-308 152-45 132 20 278 144 326zM14873 6033l1345 1200c101 90 253 76 338-31s71-269-30-359l-1345-1200c-102-90-253-76-338 31-85 108-72 268 30 359zM13887 7180l879 1619c66 121 212 162 327 93 114-70 154-227 88-348l-879-1618c-66-121-213-163-327-92-115 70-154 226-88 346zM12716 7939l306 1841c23 137 147 230 277 205 131-24 218-156 195-294l-305-1840c-23-138-148-231-278-206-130 24-217 156-195 294zM10944 8399v1869c0 140 108 254 240 254s240-114 240-254V8399c0-140-108-253-240-253s-240 113-240 253z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
